module.exports = __webpack_public_path__ + "static/media/documents.5f90406b.svg";